import { SelectProps } from "@cofano/cck/Select/Select";
import { Select } from "@cofano/cck";
import { AdnCargoTankDesign } from "view/ships/types/ship";

const AdnCargoTankDesignSelect = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {
	return (
		<Select
			disableSearch
			fetchOptions={Object.keys(AdnCargoTankDesign)}
			getOptionLabel={opt => `${opt}. ${AdnCargoTankDesign[opt as keyof typeof AdnCargoTankDesign]}`}
			multiple={false}
			value={value}
			onChange={onChange} />
	);
};

export default AdnCargoTankDesignSelect;
